import { Module } from "vuex";
import { RootState } from "@/store/RootState";
import { mutations } from "@/components/alert/store/mutations";
import { getters } from "@/components/alert/store/getters";
import { actions } from "@/components/alert/store/actions";
import { AlertState, AlertType } from "@/components/alert/types";

export const state: AlertState = {
  show: false,
  message: "",
  alertType: AlertType.Info
};

export const alert: Module<AlertState, RootState> = {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
};
